(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const loadHoverImage = (card) => {
    if (!canHover.matches) return;

    const image = card?.querySelector('.ow-online-card__image--secondary[data-bg-src]');
    if (!image) return;

    image.style.backgroundImage = `url("${image.dataset.bgSrc}")`;
    image.removeAttribute('data-bg-src');
  };

  document.addEventListener('pointerover', (event) => {
    loadHoverImage(event.target.closest('.ow-online-card'));
  }, { passive: true });

})();
